import { z } from 'zod';

import { FormType, UISubmissionStatuses } from './form-status';

// TODO this is the current statuses at the time of creating
export const EVENT_STATUS = ['PENDING', 'PROCESSING', 'COMPLETED', 'FAILED', 'ERROR'] as const;

export const EVENT_TYPE = ['CREATE', 'DELETE', 'MATCHSOURCE', 'UIPATH', 'AWS'] as const;

export const CreateSubmissionDetail = z.object({
    rid: z.string(),
    tcId: z.number(),
    grid: z.string().optional(),
    formType: FormType,
    created: z.string(),
    notify: z.array(z.string()),
}).refine(val => {
    if (val.formType === "F10") return !!val.grid;
    return true;
}, {
    message: "GRID is required for F10 form type",
});
export type CreateSubmissionDetail = z.infer<typeof CreateSubmissionDetail>;

export const Event = z.object({
    event: z.string(),
    status: z.enum(EVENT_STATUS),
    eventType: z.enum(EVENT_TYPE),
    createdOn: z.union([z.string().datetime(), z.date()]),
    metadata: z.any().optional(), // TODO add a bit more structure to this
});

export type Event = z.infer<typeof Event>;

// TODO document ui types
export const SubmissionDetail = z.object({
    id: z.number(),
    rid: z.string(),
    tcId: z.number(),
    formType: FormType,
    created: z.string(),
    notify: z.array(z.string()),
    submissionId: z.number(),
    createdOn: z.union([z.string().datetime(), z.date()]),
    events: z.array(Event).min(1),
    status: z.enum(UISubmissionStatuses),
    grid: z.string().nullable(),
}).refine(val => {
    if (val.formType === "F10") return !!val.grid;
    return true;
});
export type SubmissionDetail = z.infer<typeof SubmissionDetail>;

export const CreateSubmissionSubmissionDetail = z.object({
    id: z.number(),
    rid: z.string(),
    tcId: z.number(),
    grid: z.string().nullish(),
    formType: FormType,
    created: z.string(),
    notify: z.array(z.string()),
}).refine(val => {
    if (val.formType === "F10") return !!val.grid;
    return true;
});

export const CreateSubmissionResponse = z.object({
    id: z.number(),
    tcId: z.number(),
    created: z.string(),
    createdOn: z.union([z.string().datetime(), z.date()]),
    submissionDetails: z.array(CreateSubmissionSubmissionDetail),
});

export type CreateSubmissionResponse = z.infer<typeof CreateSubmissionResponse>;

export const CreateSubmissionQueuePayload = z.object({
    submissionDetailsId: z.number(),
    tcIds: z.number().array(),
    isAllTcsUser: z.boolean(),
});

export type CreateSubmissionQueuePayload = z.infer<typeof CreateSubmissionQueuePayload>;
